import styled, { css } from 'styled-components';

import { ReactComponent as VerificationIcon } from '@pkg/components/Sections/Profile/icons/verified.svg';

import { Typography } from '../../../../../../../../../../../components/DesignSystem';

interface Props {
    $disabled: boolean;
}

export const NftDescriptionWrapper = styled.div<Props>`
    padding-top: 15px;

    ${({ $disabled }) =>
        $disabled &&
        css`
            pointer-events: none;
            opacity: 0.3;
        `}
`;

export const StyledCollectionTypography = styled(Typography)`
    transition: opacity ${({ theme }) => theme.transitions.speeds.fast}s;
`;

export const CollectionWrapper = styled.div`
    display: flex;
    margin-bottom: 12px;
    align-items: center;

    &:hover ${StyledCollectionTypography} {
        opacity: 0.6;
    }
`;

interface SelectedProps {
    $selected?: boolean;
}

export const StyledVerificationIcon = styled(VerificationIcon)<SelectedProps>`
    margin-right: 8px;
    min-width: 16px;
    min-height: 16px;
    max-width: 16px;
    max-height: 16px;

    path {
        transition: fill ${({ theme }) => theme.transitions.speeds.normal}s;
        fill: ${({ $selected, theme }) => ($selected ? theme.colors.purpleDark : theme.colors.purple)};
    }
`;

export const StyledTitleTypography = styled(Typography)`
    margin-bottom: 7px;
`;
